// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__x1z2r","left":"Divider_left__LOArA","center":"Divider_center__uONcI","right":"Divider_right__zp66a"};